import { Link } from 'gatsby';
import { Highlight, Snippet } from 'react-instantsearch-hooks-web';
import { Hit as HitType } from 'instantsearch.js';
import tw, { css, styled } from 'twin.macro';
import useGlobalData from '@hooks/useGlobalData';
import { SendEventForHits } from 'instantsearch.js/es/lib/utils';

function Hit({ hit, sendEvent }: { hit: HitType; sendEvent: SendEventForHits }) {
  const { getInternalLink } = useGlobalData();
  const linkUrl = getInternalLink({ codename: hit.codename });

  return (
    <StyledLink
      to={linkUrl}
      onClick={() => {
        // NOTE Algolia doesn't support using useCallback for this function here
        sendEvent('click', hit, 'Clicked on a result');
      }}
    >
      <StyledHighlight attribute="title" hit={hit} />
      <StyledSnippet attribute="content" hit={hit} />
    </StyledLink>
  );
}

const StyledLink = styled(Link)(() => [
  tw`block hover:bg-menu-hover px-3 pt-3 pb-5`,
  css`
    mark {
      ${tw`bg-search-hit`}
    }
  `,
]);

const StyledHighlight = styled(Highlight)(() => [tw`pb-2 font-bold`]);
const StyledSnippet = styled(Snippet)(() => [tw`block text-xs`]);

export default Hit;
